import { House } from 'lucide-react';
import { createElement, lazy, type ComponentType } from 'react';
import type { FeatureModule } from '@/app/contract';
import { APP_ROUTES } from '@/app/paths';
import { presentSearch } from './entries';
import { registerNamespace } from '@/i18n';
import en from './locales/en.json';
import zh from './locales/zh-Hans.json';

registerNamespace('home', { en, 'zh-Hans': zh });

// The shell wraps route components in React.lazy itself. Keep this adapter a function,
// with the actual screen still split into its own chunk (React rejects lazy-of-lazy).
function lazyScreen(load: () => Promise<{ default: ComponentType }>): ComponentType {
  const Screen = lazy(load); return function HomeRoute() { return createElement(Screen); };
}

const feature: FeatureModule = {
  id: 'home',
  section: { id: 'home', titleKey: 'home:title', icon: House },
  routes: [
    { ...APP_ROUTES.home, component: lazyScreen(() => import('./Home')) },
    { ...APP_ROUTES.archived, component: lazyScreen(() => import('./Home').then(module => ({ default: module.Archived }))) },
    { ...APP_ROUTES.search, component: lazyScreen(() => import('./Search')) },
    { ...APP_ROUTES.needsYou, component: lazyScreen(() => import('./NeedsYou')) },
  ],
  commands: [
    { id: 'home.search', titleKey: 'home:search.title', shortcut: 'mod+k', run: presentSearch },
  ],
};

export default feature;
